import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import { formatQueryParams } from "helpers/format";
import redeemCodeApi from "api/redeemCodeApi";

export const getRedeemCodeList = createAsyncThunk(
  "RedeemCode",
  async (params: any = {}) => {
    try {
      const response = await redeemCodeApi.getRedeemCodeList(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getRedeemCodeDetail = async (
  id: string | number,
  params: any = {}
) => {
  try {
    const response = await redeemCodeApi.getRedeemCodeDetail(id, params);
    return response;
  } catch (error) {
    return error;
  }
};

export const postRedeemCode = async (data: any = {}) => {
  try {
    const response = await redeemCodeApi.createRedeemCode(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putRedeemCode = async (id: string | number, data: any = {}) => {
  try {
    const response = await redeemCodeApi.updateRedeemCode(id, data);
    return response;
  } catch (error) {
    return error;
  }
};
